
export const SAVE_ADDRESS = 'SAVE_ADDRESS'
export const SAVE_SEARCHKEY = 'SAVE_SEARCHKEY'
export const SAVE_CARTLIST = 'SAVE_CARTLIST'
export const SAVE_CATEGORYTYPE = 'SAVE_CATEGORYTYPE'
export const SAVE_ACTIVECITY = 'SAVE_ACTIVECITY'
export const SAVE_ORDERLIST = 'SAVE_ORDERLIST'
export const SET_POSITION = 'SET_POSITION'
export const SAVE_PAGE = 'SAVE_PAGE'

export const SET_ACTIVELOCAL = 'SET_ACTIVELOCAL'



// WEBPACK FOOTER //
// ./src/story/mutation-types.js